/**
 * Blurs the currently focused element, if there is one.
 *
 * Call it synchronously right before opening a MUI dialog — otherwise the
 * trigger keeps focus inside the background that MUI marks `aria-hidden` on
 * open, which Chrome warns about ("Blocked aria-hidden … descendant retained
 * focus"). Also used before submitting a form to dismiss the mobile keyboard
 * and commit the active input.
 */
export const blurActiveElement = () => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
};

export const focusWithoutScrolling = (element: HTMLElement) => {
    if (!element.hasAttribute("tabindex")) {
        element.setAttribute("tabindex", "-1");
        element.addEventListener("blur", () => element.removeAttribute("tabindex"), { once: true });
    }

    element.focus({ preventScroll: true });
};
